import React from 'react'
import MyRoutes from './routes/MyRoutes'

const App = () =>
{
  return (
    <>
      <MyRoutes />
    </>
  )
}

export default App